import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';

interface Ach { earned: boolean; progress: number; target: number }
interface AchData {
  primaUscita: Ach; instancabile: Ach; macchinaDaFuoco: Ach;
  veterano: Ach; nottambulo: Ach;
}

/**
 * Achievement PER ANNO: la card segue l'anno selezionato dal filtro della
 * pagina interventi (progressi/badge di QUELL'anno). Anno nella queryKey per
 * non servire dalla cache i dati di un altro anno.
 */
export function Achievements({ year }: { year: number }): React.JSX.Element {
  const { data } = useQuery<AchData>({
    queryKey: ['achievements', year],
    queryFn: async () => (await api.get('/interventions/achievements', { params: { year } })).data,
  });
  if (!data) return <div />;

  // Ordine + label + colore allineati alla legacy index.html
  const list = [
    { key: 'primaUscita', label: '🎖️ Prima Uscita', cls: '', ach: data.primaUscita },
    { key: 'instancabile', label: '💪 Instancabile', cls: 'bronze', ach: data.instancabile },
    { key: 'macchinaDaFuoco', label: '🔥 Macchina da Fuoco', cls: 'silver', ach: data.macchinaDaFuoco },
    { key: 'veterano', label: '⭐ Veterano', cls: 'gold', ach: data.veterano },
    { key: 'nottambulo', label: '🌙 Nottambulo', cls: 'night', ach: data.nottambulo },
  ];

  return (
    <div className="card">
      <h3>🏅 Achievement {year}</h3>
      {list.map(a => (
        <div key={a.key} style={{ marginBottom: 12 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
            {a.ach.earned ? (
              <span className={`achievement-badge ${a.cls}`} style={{ fontSize: 13, padding: '6px 14px', margin: 0 }}>
                {a.label}
              </span>
            ) : (
              <span style={{ color: '#999', fontSize: 14 }}>🔒 {a.label}</span>
            )}
            <span style={{ fontSize: 13, color: '#666', fontWeight: 600 }}>{a.ach.progress}/{a.ach.target}</span>
          </div>
          <div style={{ background: '#eee', height: 6, borderRadius: 3, overflow: 'hidden' }}>
            <div style={{
              height: '100%',
              width: `${Math.min(100, (a.ach.progress / a.ach.target) * 100)}%`,
              background: a.ach.earned ? '#28a745' : '#e74c3c',
              transition: 'width 0.4s ease',
            }} />
          </div>
        </div>
      ))}
    </div>
  );
}
